import { Component, Input } from '@angular/core';
import { DxDropDownButtonModule } from 'devextreme-angular/ui/drop-down-button';

@Component({
  selector: 'dk-task-card-menu',
  templateUrl: './task-card-menu.component.html',
  styleUrls: ['./task-card-menu.component.scss'],
  standalone: true,
  imports: [DxDropDownButtonModule],
})
export class TaskCardMenuComponent {
  @Input() items: Array<{ text: string }>;
  @Input() visible = true;

  constructor() {

  }
}
